import formCompletions from './formCompletions';

const requests ={
    organizations: {
        formCompletions: formCompletions.formCompletions
    }
}

export default requests;